import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Modal, Button, OutlineCard } from '@morressier/alembic';
import { FormProvider, useForm } from 'react-hook-form';
import { ajvResolver } from '@hookform/resolvers/ajv';
import _ from 'lodash';
import { FormFieldDateInput } from '@publishing-engine/domain/types/article';
import { generateValidationSchema } from 'src/utils/validation';
import { FormFieldDefinition } from '@publishing-engine/domain/types/article';
import { FormFieldDate } from '../../../FormField';

interface IProps {
  isOpen: boolean;
  onSubmit: (value: string) => void;
  onCancel: () => void;
  formField: FormFieldDateInput;
  value?: string;
}

type IDateFormState = {
  [key: string]: string;
};

export const DateUpdateModal: React.FC<IProps> = props => {
  const { isOpen, onSubmit, onCancel, formField } = props;
  let { value } = props;

  if (value === null) {
    value = '';
  }

  const schema = generateValidationSchema({
    [formField.name]: formField
  } as Record<string, FormFieldDefinition>);

  const methods = useForm({
    defaultValues: _.set(
      {} as IDateFormState,
      formField.caseDataFields.main,
      value
    ),
    resolver: ajvResolver(schema)
  });

  const { handleSubmit } = methods;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection="column" gap={8}>
        <FormProvider {...methods}>
        <form
          onSubmit={handleSubmit(data => {
            onSubmit(_.get(data, formField.caseDataFields.main));
          })}
        >
          <OutlineCard borderless padding={8} width="100%">
            <Flex flexDirection="column" gap={2}>
              <Text textStyle="headingSection">{`Update ${formField.params.labels.main}`}</Text>
            </Flex>
            <Flex flexDirection="column" gap={2}>
              <FormFieldDate config={formField} />
              <Flex gap={2} justifyContent="flex-end">
                <Button
                  variant="secondary"
                  onClick={onCancel}
                  borderRadius="small"
                >
                  Exit Without Saving
                </Button>
                <Button variant="primary" type="submit" borderRadius="small">
                  Save Changes
                </Button>
              </Flex>
            </Flex>
          </OutlineCard>
        </form>
        </FormProvider>
      </Flex>
    </Modal>
  );
};
